import React, {
  useRef,
  useState,
  MouseEvent,
  SyntheticEvent,
  useEffect,
  useCallback,
} from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { History, Location } from 'history';

import { resetAllAfterLogout } from 'actions/authenticate';
import { WeaverApiClientInstance } from 'api/weaverApiClientInstance';
import { requestLogout } from 'services/authenticate';
import { clearPaginateStorage } from 'utils/paginateStorage';

import MenuItems from '../MenuItems';
import './styles.scss';

interface IOwnProps {
  currentUserRoles: string[];
  currentUserScopes: string[];
  history: History;
  location: Location;
}

interface IDispatchProps {
  resetAllAfterLogout: () => void;
}

type MenuProps = IOwnProps & IDispatchProps;

const Menu = (props: MenuProps) => {
  const menuRef = useRef(null);
  const [isShown, setIsShown] = useState<boolean>(false);

  const hide = useCallback(() => {
    if (isShown) {
      setIsShown(false);
    }
  }, [isShown]);

  const handleToggle = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setIsShown(!isShown);
  };

  const handleClickOutside = useCallback(() => {
    if (menuRef) {
      hide();
    }
  }, [hide]);

  const handleLogout = async (e: SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    await requestLogout();
    WeaverApiClientInstance.reset();
    props.resetAllAfterLogout();
    clearPaginateStorage();
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);

  const { currentUserRoles = [], currentUserScopes = [] } = props;
  const buttonStyle = isShown ? 'button-opened' : 'button-closed';

  return (
    <div ref={menuRef} styleName="hamburger" data-testid="menu">
      <div styleName="dropdown-button">
        <nav>
          <button
            data-testid="hamburger-btn"
            styleName={buttonStyle}
            type="button"
            onClick={handleToggle}
            aria-label="Toggle Navigation Menu"
          />
        </nav>
        {isShown && (
          <MenuItems
            handleLogout={handleLogout}
            currentUserRoles={currentUserRoles}
            currentUserScopes={currentUserScopes}
          />
        )}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      resetAllAfterLogout,
    },
    dispatch,
  );

export default withRouter<any, any>(connect(null, mapDispatchToProps)(Menu));
